/*
 * @Author: etong
 * @Date: 2021-12-18 16:59:13
 * @LastEditTime: 2022-08-08 19:10:25
 * @LastEditors: your name
 * @Description: 联动相关的操作方法
 * @FilePath: \oak\src\utils\lowcodeUtil\linkMethods.js
 * Think first, Program later
 */
import { merge, cloneDeep } from 'lodash'
import { number_format } from '@/utils/index'
var formItemObj = {}
// /**
//  * @description: 计算汇率影响后的数据值
//  * @param  originAmout {Number} 原始值
//  * @param  exchangeRate {Number} 汇率
//  * @param  _this {Vue | Object} this实例
//  * @return {Number} 计算后的值
//  */
// const copmuteExchangeAmount = function(params) {
//   console.log('计算的参数', params)
//   const { originAmout, exchangeRate, _this } = params
//   return 123
// }
/**
 * @description: 计算值通用方法
 * @param {Object} config 公式配置数据
 * config values - 数据源
 * config formatOptions - 数据源格式化
 * @param {String} op 操作符
 * + 加法
 * - 减法
 * * 乘法
 * / 除法
 * @return {Number} 计算后的数值
 */
function computeValue(config, op) {
  const { values, formatOptions } = config

  /**
   * 需要判断长度
   * 大于等于2 才进行运算
   * 否则直接返回
   */
  if (values.length >= 2) {
    let sumNums = 0
    console.log('op', op)
    switch (op) {
      case '+':
        sumNums = values.reduce((pre, cur) => {
          return pre + cur
        }, 0)
        break
      case '-':
        sumNums = values.reduce((pre, cur) => {
          return pre - cur
        })
        break
      case '*':
        sumNums = values.reduce((pre, cur) => {
          return pre * cur
        })
        break
      case '/':
        sumNums = values.reduce((pre, cur) => {
          return pre / cur
        })
        break
      default:
        break
    }
    return sumNums
  } else {
    return values[0]
  }
}

/**
 * @description: 低代码通用加法
 * @param {*} config
 * @return {*}
 */
const lowcodeAdd = function(config) {
  return computeValue(config, '+')
}

/**
 * @description: 低代码通用减法
 * @param {*}
 * @return {*}
 */
const lowcodeSubtract = function(config) {
  return computeValue(config, '-')
}

/**
 * @description: 低代码通用乘法
 * @param {*}
 * @return {*}
 */
const lowcodeMultiply = function(config) {
  return computeValue(config, '*')
}

/**
 * @description: 低代码通用除法
 * @param {*}
 * @return {*}
 */
const lowcodeDivide = function(config) {
  return computeValue(config, '/')
}

const getItemFromFormItemList = function(key, _this) {
  console.log('key1', key)
  console.log('_this', _this)
  if (!(key in formItemObj)) {
    formItemObj[key] = {}
  }
  const formItemList = _this['formItemList']
  console.log('formItemList', formItemList.filter(item => item.key === key))
  const itemCp = cloneDeep(formItemList.filter(item => item.key === key)[0])
  formItemObj[key] = itemCp

  console.log('formItemObj[key]', formItemObj[key])
  return formItemObj[key] || {}
}

export default {
  lowcodeAdd,
  lowcodeSubtract,
  lowcodeMultiply,
  lowcodeDivide,
  getItemFromFormItemList
}
